// extracted by mini-css-extract-plugin
export default {"carouselImage":"MarketplaceShowView_carouselImage__0KHIT","deleteIcon":"MarketplaceShowView_deleteIcon__sgnc0","favourite":"MarketplaceShowView_favourite__+z2T4"};